/**
 * @description Channel Partner admin. sidebar (LYN-309)
 *
 * @dependencies CHANNEL_PARTNER_NAV, lucide-react, react-router-dom
 * @notes Foundation order only. Audit-log nav is hidden this cut.
 */

import { Link, useLocation } from 'react-router-dom';
import {
  Building2,
  Handshake,
  Home,
  Plug,
  Settings,
  Store,
} from 'lucide-react';
import { CHANNEL_PARTNER_NAV } from './channelPartnerNav';

const ICONS = {
  Dashboard: Home,
  'Sales Orgs': Handshake,
  Merchants: Store,
  'My Company': Building2,
  Integrations: Plug,
  Settings,
};

const ChannelPartnerSidebar = ({ isSidebarOpen, onLinkClick, isMobile = false }) => {
  const location = useLocation();

  return (
    <>
      {CHANNEL_PARTNER_NAV.map((link) => {
        const Icon = ICONS[link.label] || Home;
        const active = location.pathname === link.to
          || location.pathname.startsWith(`${link.to}/`);
        return (
          <Link
            key={link.to}
            to={link.to}
            aria-current={active ? 'page' : undefined}
            className={`group relative flex items-center py-3 rounded-lg transition-colors duration-200 ${
              active ? 'bg-gray-800 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'
            }`}
            onClick={() => isMobile && onLinkClick && onLinkClick()}
          >
            <div className="w-12 flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5" />
            </div>
            <span className={`text-sm font-medium overflow-hidden whitespace-nowrap transition-all duration-300 ${
              isMobile ? 'opacity-100 max-w-full' : isSidebarOpen ? 'opacity-100 max-w-full delay-[50ms]' : 'opacity-0 max-w-0'
            }`}>
              {link.label}
            </span>
            {!isMobile && !isSidebarOpen && (
              <div className="absolute left-14 top-1/2 -translate-y-1/2 bg-gray-800 text-white px-2 py-1 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 pointer-events-none">
                {link.label}
              </div>
            )}
          </Link>
        );
      })}
    </>
  );
};

export default ChannelPartnerSidebar;
